export default __webpack_public_path__ + "maps-examples-default-styles-1200-9d91297421e9e8e0d28c69a20dbd8cf9.webp";